const doc = [({"da":({"js":({"components":({"admin":({"newsletter_templates":({"nav":({"users_to_receive":"Brugere der vil modtage"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;